// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

const GradientBall = (props) => {
  return (
    <span
      className={`${styles.gradient_ball} ${
        props.size === "small"
          ? styles.small
          : props.size === "medium"
          ? styles.medium
          : styles.large
      }`}
      {...props}
    />
  );
};

export default GradientBall;
